import { useCallback } from 'react';

import { useAnnotationsDispatch } from '@confluence/annotation-provider-store';

import { usePreemptiveGate } from '../hooks/usePreemptiveGate';

// for editor, EditorAnnotationProviderComponents renders CreateComponent and ViewComponent
// but for renderer, WithAnnotationsWrapper renders SelectionComponent and ViewComponent
// so we don't need to render anything here
// we could move SelectionComponent and ViewComponent from WithAnnotationsWrapper to this file
export function RendererAnnotationProviderComponents() {
	const { handleClose } = useAnnotationsDispatch();

	const onConfirm = useCallback(() => {
		handleClose();
	}, [handleClose]);

	usePreemptiveGate({ onConfirm });

	return null;
}
